"use client";

import * as React from "react";
import { Grid, Box, Typography } from "@mui/material";
import InteractiveMap from "./InteractiveMap";

const AboutUs = () => {
    return (
        <>
            <Box
                className="fp-widgets-area"
                sx={{
                    pb: { xs: "60px", sm: "60px", md: "80px", lg: "100px", xl: "150px" },
                    pt: { xs: "60px", sm: "60px", md: "80px", lg: "100px", xl: "150px" },
                    background: 'linear-gradient(to bottom right, #e0f2f7, #ffffff, #e0f7fa)',
                }}
            >
                <Box
                    sx={{
                        maxWidth: {
                            xs: "100%",
                            sm: "700px",
                            md: "720px",
                            lg: "1140px",
                            xl: "1320px",
                        },
                        mx: "auto",
                        px: "12px",
                        position: "relative",
                        zIndex: "1",
                    }}
                >
                    <Grid
                        container
                        spacing={{ xs: 4, md: 6, lg: 8 }}
                        alignItems="center"
                        sx={{
                            mb: { xs: 8, md: 12, lg: 16 },
                            pt: { xs: '60px', sm: '80px', md: '0px' },
                        }}
                    >
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="h4"
                                component="h2"
                                sx={{
                                    mb: 2,
                                    fontWeight: 'bold',
                                    fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                                    textAlign: { xs: 'center', lg: 'left' },
                                    lineHeight: 1.2,
                                    color: '#333',
                                }}
                            >
                                About YNET Solutions LTD
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    mb: 2,
                                    fontSize: { xs: '1rem', sm: '1.1rem' },
                                    lineHeight: 1.7,
                                    textAlign: { xs: 'center', lg: 'left' },
                                    color: '#555',
                                }}
                            >
                                Established in <strong>2020</strong>, YNET Solutions LTD is a dynamic technology firm dedicated to crafting innovative software solutions. Since our inception, we've empowered diverse industries including <strong>Fintech, Healthcare, Finance, and Legal</strong>, by transforming complex challenges into seamless digital experiences.
                            </Typography>
                            <Typography
                                variant="h5"
                                component="h3"
                                sx={{
                                    mt: { xs: 3, md: 4 },
                                    mb: 1,
                                    fontWeight: 'semibold',
                                    fontSize: { xs: '1.3rem', sm: '1.5rem' },
                                    textAlign: { xs: 'center', lg: 'left' },
                                    color: '#444',
                                }}
                            >
                                Our Mission
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '1rem', sm: '1.1rem' },
                                    lineHeight: 1.7,
                                    textAlign: { xs: 'center', lg: 'left' },
                                    color: '#555',
                                }}
                            >
                                To be a leading provider of smart, reliable, and impactful digital solutions that empower businesses to thrive in a connected world.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: { xs: '300px', sm: '400px', md: '450px', lg: '500px' },
                                    mt: { xs: 4, lg: 0 },
                                    px: { xs: 0, sm: 2 },
                                }}
                            >
                                <InteractiveMap />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ mb: { xs: 8, md: 12, lg: 16 } }}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                component="h2"
                                sx={{
                                    mb: 2,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                                    lineHeight: 1.2,
                                    color: '#333',
                                }}
                            >
                                Our Vision for Tomorrow
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '1.1rem', sm: '1.2rem' },
                                    lineHeight: 1.8,
                                    textAlign: 'center',
                                    maxWidth: '800px',
                                    mx: 'auto',
                                    color: '#555',
                                }}
                            >
                                We envision a future where technology seamlessly augments human potential. Through <strong>Agentic AI, hyper-personalized experiences, and universally accessible integrations</strong>, we are building a world where businesses operate with unparalleled efficiency, insights are instantly actionable, and every interaction creates lasting value. YNET Solutions LTD is committed to leading this transformation, one intelligent solution at a time.
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Shape Images */}
                    <div className="shape1">
                        <img
                            src="/images/front-pages/shape1.png"
                            alt="shape1"
                            width={530}
                            height={530}
                        />
                    </div>
                    <div className="shape2">
                        <img
                            src="/images/front-pages/shape2.png"
                            alt="shape2"
                            width={447}
                            height={453}
                        />
                    </div>
                </Box>
            </Box>
        </>
    );
};

export default AboutUs;